export default {

  // API地址
  baseUrl: document.getElementById('society_api').getAttribute('data-url') === 'http://tubo.io/api' ? 'http://demo.gzw.xin/sealsite/1000' : document.getElementById('society_api').getAttribute('data-url'),

  // OSS图片查看地址
  photoUrl: document.getElementById('society_api').getAttribute('data-img-url'),

  libBaseSaas: {

    // 获取词典文件
    dict: '/api/v1/saas/dict/:file',

    // 获取前端配置文件-指定记录
    setupFront: '/api/v1/saas/site/setup/front',
  },

  libBaseUtil: {
    // 防暴力破解-图片生成
    kaptcha: '/api/v1/lib/util/kaptcha/',
  },

  libThird: {
    //  发送短信验证码
    smsSend: '/api/v1/lib/third/sms/send',

    //发送短信验证码-需校验验证码
    smsSendKaptcha: '/api/v1/lib/third/sms/send/kaptcha',

    // 上传图片, 返回图片相对路径（在OSS中的路径）
    oss: '/api/v1/lib/third/oss',

    // 人脸识别, 通过两个URL
    faceVerifyUrl: '/api/v1/lib/third/face/verify/url',

    // 获取微信的jsTicket
    wxJsTicket: '/api/v1/third/wx/jsTicket',
  },

  // LIB-THIRD-OAuth登录接口
  libThirdOAuth: {

    // 微信登录跳转-需要确认能获取用户昵称头像
    wxConfirm: '/api/v1/lib/third/oauth/wx/confirm',

    // 微信登录跳转-不需要确认
    wxSilent: '/api/v1/lib/third/oauth/wx/silent',

    // 支付宝登录跳转-需要确认能获取用户昵称头像
    aliLoginConfirm: '/api/v1/lib/third/ali/login/confirm',

    // 支付宝登录跳转-不需要确认
    aliLoginSilent: '/api/v1/lib/third/ali/login/silent'

  },

  libSys: {},

  libSysAdmin: {},

  libSysUser: {},

  libClient: {
    // 无需登录-用户列表/详情
    user: '/api/v1/client/user/:id',

    // 无需登录-查询POI需要显示的企业列表
    companyQueryPoi: '/api/v1/client/company/query/poi',

    // 无需登录-根据6位地区代码获取bizScope可支持的企业
    companyScope: '/api/v1/client/company/scope',

    // 无需登录-根据6位地区代码获取bizScope可支持的企业
    companyBiz: '/api/v1/client/company/biz',

    // 无需登录-查看企业详情
    company: '/api/v1/client/company/:id',
  },

  libClientCliCompany: {},

  libClientCliUser: {},

  libClientSys: {},

  libClientSysCompany: {
    // 特行企业-列表
    company: '/api.sys/v1/sys/client/company/:id',

    // 特行企业-管辖范围内所有企业变更记录-列表
    alteration: '/api.sys/v1/sys/client/company/alteration/:id',

    // 特行企业-注册信息变更（备案后变更会记录日志）
    opAlter: '/api.sys/v1/sys/client/company/op/alter/:id',

    // 特行企业-备案提交审核
    opSubmit: '/api.sys/v1/sys/client/company/op/submit/:id',

    // 特行企业-更改企业老板（所有者）
    opAdmin: '/api.sys/v1/sys/client/company/op/admin/:id',

    // 特行企业-备案核准操作
    opAudit: '/api.sys/v1/sys/client/company/op/audit/:id',

    // 特行企业-扩展信息修改
    opExt: '/api.sys/v1/sys/client/company/op/ext/:id'
  },

  libClientInfo: {
    // 文章列表
    article: '/api/v1/info/article/:id'
  },

  libCustom: {
    //判断手机号是否有用户
    opMobilePeek: '/api/v1/lib/custom/op/user/mobile/peek',

    //  用户登录-使用账号密码
    opLoginPass: '/api/v1/lib/custom/op/user/login/pass',

    //  用户登录-使用短信验证码
    opLoginSms: '/api/v1/lib/custom/op/user/login/sms',

    // 用户登录-APP使用微信返回的信息向服务器求证
    opLoginWxApp: '/api/v1/lib/custom/op/user/login/wx/app',

  },

  libCustomCusUser: {
    //修改资料
    opChangeData: '/api.cus/v1/lib/custom/cus/user/op/change_data',

    //修改密码
    opChangePass: '/api.cus/v1/lib/custom/cus/user/op/change_pass',

    //修改手机号
    opChangeMobile: '/api.cus/v1/lib/custom/cus/user/op/change_mobile',

    //  用户获取自己资料
    queryData: '/api.cus/v1/lib/custom/cus/user/query/data',

    //  用户注销
    opLogout: '/api.cus/v1/lib/custom/cus/user/op/logout',
  },

  libCustomSysUser: {},

  gzw: {
    queryOrg: '/api/v1/society/seal/site/query/org',

    // 通过印章识别码查询印章详情
    sealContentIdentity: '/api/v1/gzw/seal/content/identity/:identity',

    //
    sealOrgUscc: '/api/v1/gzw/seal/org/uscc/:uscc',
  },

  gzwCusDz: {
    //电子公章-列表/详情/新增/编辑/删除
    dzSeal: '/api.cus/v1/gzw/cus/dz/seal/:id',

    //电子公章-获取微信扫码图片
    dzPayWxScan: '/api.cus/v1/gzw/cus/dz/pay/wx/scan/',

    //电子公章-支付宝PC-WEB唤起页面
    dzPayAlipayPc: '/api.cus/v1/gzw/cus/dz/pay/alipay/pc/',
  },

  gzwCusOrder: {
    // 拉取法定代表人手机号和经办人手机号相符的推送信息
    aic: '/api.cus/v1/gzw/cus/order/aic',

    // 根据工商订单选择线下办理并选择刻章企业
    aicOffline: '/api.cus/v1/gzw/cus/aic/offline',

    // 根据工商推送生成实物公章订单
    importAic: '/api.cus/v1/gzw/cus/order/import/aic',

    // 印章刻制订单-当前订单列表
    orderActive: '/api.cus/v1/gzw/cus/order/active',

    // 印章刻制订单-历史订单列表
    orderHistory: '/api.cus/v1/gzw/cus/order/history',

    // 印章刻制订单-新增/编辑/详情/删除
    order: '/api.cus/v1/gzw/cus/order/:id',

    // 印章订单-印章-列表/新增/编辑/删除
    orderSeal: '/api.cus/v1/gzw/cus/order/seal/:id',

    // 印章订单-支付宝PC-WEB唤起页面
    orderPayAlipayPc: '/api.cus/v1/gzw/cus/order/pay/alipay/pc/',

    //印章订单-支付宝MOBILE-WEB唤起页面
    payAlipayMobile: '/api.cus/v1/gzw/cus/order/pay/alipay/mobile/',

    // 印章订单-获取微信扫码图片
    orderPayWxScan: '/api.cus/v1/gzw/cus/order/pay/wx/scan/',

    // 印章订单-获取章材列表
    queryMaterial: '/api.cus/v1/gzw/cus/order/query/material',

    // 微信WEB唤起支付
    orderPayWxH5: '/api.cus/v1/gzw/cus/order/pay/wx/h5/',

    // 印章订单-微信JSAPI支付数据MAP返回
    orderPayWxJsapi: '/api.cus/v1/gzw/cus/order/pay/wx/jsapi/:id',
  },

}
